// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"5dddd289","115":"c7e5add3","315":"55fb6832","447":"a21c083d","614":"27340e79","774":"6a801572","793":"75dac212"}[chunkId] + ".chunk.js";
};